import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import Moment from 'moment';
import Calendar from 'react-calendar';
import MemberDataService from '../../services/MemberDataService';


export default class MemberCreate extends Component {
    constructor() {
        super()
        this.state = {
            "address": "",
            "birthdate": new Date(),
            "fatherName": "",
            "gender": "",
            "identity": "",
            "isAlive": "",
            "isMarried": "",
            "motherName": "",
            "name": "",
            "partnerId": "",
            "phoneNumber": "",
            successful: false,
            message: "",
            errors: {}
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    createMember(memberData) {
        MemberDataService.createMember(memberData)
            .then((response) => {
                this.setState({
                    message: response.data.message,
                    successful: true
                });
                window.open('/family-members', "_self");
            },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        successful: false,
                        message: resMessage
                    });
                }
            );
    }



    onChangeDate = birthdate => this.setState({birthdate});

    onChange(event) {
        //that means that every event.target. name (the name in the elements) to assign the value to it. 
        this.setState({ [event.target.name]: event.target.value })
    }

    onSubmit(event) {
        event.preventDefault()
        const newMember = {
            address: this.state.address,
            birthdate: Moment(this.state.birthdate).format('DD-MM-YYYY'),
            fatherName: this.state.fatherName,
            gender: this.state.gender,
            identity: this.state.identity,
            isAlive: this.state.isAlive,
            isMarried: this.state.isMarried,
            motherName: this.state.motherName,
            name: this.state.name,
            partnerId: "",
            phoneNumber: this.state.phoneNumber,
        };
        this.createMember(newMember);
    }



    render() {

        return (
            <div className="mainCreate">
                <div className="top-container-forms  membercreate-topform">
                    <div className="create-form membercreate-form">

                        <h1>اضافة شخص جديد</h1>

                        <form onSubmit={this.onSubmit}>
                            <div className="form-group-create">
                                <h5> الأسم </h5>
                                <input
                                type="text"
                                    name="name" placeholder="Name"
                                    value={this.state.name}
                                    onChange={this.onChange}
                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأب </h5>
                                <input type="text" className="form-control-form-cont" name="fatherName" placeholder="Father Name"
                                    value={this.state.fatherName}
                                    onChange={this.onChange}

                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأم </h5>
                                <input type="text" className="form-control-form-cont" name="motherName" placeholder="Mother Name"
                                    value={this.state.motherName}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> رقم الهاتف </h5>
                                <input type="text" className="form-control-form-cont" name="phoneNumber" placeholder="Phone Number"
                                    value={this.state.phoneNumber}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> العنوان </h5>
                                <input type="text" className="form-control-form-cont" name="address" placeholder="Address"
                                    value={this.state.address}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="form-group-create">
                                <h5> رقم الهويّة </h5>
                                <input type="text" className="form-control-form-cont" name="identity" placeholder="Identity"
                                    value={this.state.identity}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> تاريخ الميلاد </h5>
                                   <Calendar className="react-calendar"
                                    onChange={this.onChangeDate}
                                    value={this.state.birthdate}
                                    />
                            </div>
                            <div className="form-group-create">
                                <h5> الجنس </h5>
                                <select className="form-control-form-cont" name="gender" onChange={this.onChange} >
                                    <option value="">الجنس؟  </option>
                                    <option value="female">انثى</option>
                                    <option value="male">ذكر</option>

                                </select>
                            </div>
                            <div className="form-group-create">
                                <h5> الحالة الاجتماعيّة </h5>
                                <select className="form-control-form-cont" name="isMarried" onChange={this.onChange} >
                                    <option value="">الحالة الاجتماعيّة؟ </option>
                                    <option value="yes">متزوج</option>
                                    <option value="no">غير متزوج</option>
                                </select>
                            </div>
                            <div className="form-group-create">
                                <h5> على قيد الحياة؟</h5>
                                <select className="form-control-form-cont" name="isAlive" onChange={this.onChange} >
                                    <option value="yes">is Alive ?</option>
                                    <option value="yes">Alive</option>
                                    <option value="no">Not Alive</option>
                                </select>
                            </div>
                            <button className="btn" onClick={this.props.history.goBack}> للعودة  </button>
                            <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" />

                            {this.state.message && (
                                <div className="form-group">
                                    <div
                                        className={
                                            this.state.successful
                                                ? "alertSuccess"
                                                : "alertDanger"
                                        }
                                        role="alert"
                                    >
                                        {this.state.message}
                                    </div>
                                </div>
                            )}

                        </form>

                    </div>

                </div></div>


        )
    }
}
